import React from "react";
import PageHero from "../components/PageHero";
import AboutStory from "../sections/AboutStory";
import Location from "../sections/Location";

export default function About() {
  return (
    <>
      <PageHero
        title="Our Story"
        subtitle="About Mariner Lodge"
        description="A tiny guest house on a panoramic perch above the Indus — built for those who seek beauty beyond the ordinary."
        image="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1600&q=80"
      />
      <AboutStory />
      <Location />
    </>
  );
}